type TApiFieldError = {
  pointer: string
  message: string
}

type TMappedFieldError<TField extends string> = {
  field: TField
  message: string
}

export const mapApiFieldErrors = <TField extends string>(
  errors: TApiFieldError[],
  fieldByPointer: Readonly<Partial<Record<string, TField>>>
): TMappedFieldError<TField>[] | null => {
  const mappedErrors: TMappedFieldError<TField>[] = []
  const usedFields = new Set<TField>()

  const areAllErrorsMapped = errors.every((error) => {
    const field = fieldByPointer[error.pointer]

    if (!field) return false

    if (!usedFields.has(field)) {
      usedFields.add(field)
      mappedErrors.push({ field, message: error.message })
    }

    return true
  })

  return areAllErrorsMapped ? mappedErrors : null
}
